"use strict";

exports.__esModule = true;
exports.PlantCalendar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBigCalendar = require("react-big-calendar");
var _styledComponents = require("styled-components");
var _moment = _interopRequireDefault(require("moment"));
var _PlantStateActivities = require("../PlantStateActivities");
var _styledComponents2 = require("./styledComponents");
var _dynamicMomentLocaleImports = require("../../Utils/dynamicMomentLocaleImports");
var _timeDefinitions = require("../timeDefinitions");
var _excluded = ["component", "calendar", "plantStateActivities", "theme", "onSelectEvent", "selectedEvent"];
var _dec, _class, _PlantCalendar;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var localeKey = localStorage.getItem("vi-locale-key") || "en-us";
(0, _dynamicMomentLocaleImports.importMomentLocales)(localeKey);
var PlantCalendar = exports.PlantCalendar = (_dec = _PlantStateActivities.PlantStateActivitiesContext.withContext, _dec(_class = (0, _styledComponents.withTheme)(_class = (_PlantCalendar = /*#__PURE__*/function (_Component) {
  function PlantCalendar() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      date: _this.props.date,
      prevPropsDate: _this.props.date,
      view: "week"
    };
    _this.getEventTitle = function (event) {
      if (!event.payload) {
        return /*#__PURE__*/_react["default"].createElement("em", null, "Unnamed ", event.type);
      }
      if (event.type !== "Classification") {
        return event.payload.name;
      }
      var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_this.props.plantStateActivities);
      if (!event.payload.state) {
        return "Unknown";
      }
      var stateLabel = (0, _PlantStateActivities.getPlantStateOrThrow)(plantStateActivities.states, event.payload.state).name;
      if (event.payload.activity) {
        var activityLabel = (0, _PlantStateActivities.getPlantActivityOrThrow)(plantStateActivities.activities, event.payload.activity).name;
        return stateLabel + ": " + activityLabel;
      }
      return stateLabel;
    };
    _this.getEventStart = function (event) {
      return new Date(event.interval.startMillis);
    };
    _this.getEventEnd = function (event) {
      return new Date(event.interval.endMillis);
    };
    _this.getEventProps = function (event) {
      var isSelected = _this.props.selectedEvent && _this.props.selectedEvent.sourceId === event.sourceId;
      if (event.type === "Holiday") {
        return {
          style: {
            outline: isSelected ? "dashed 3px rgba(0, 0, 0, 0.2)" : undefined,
            outlineOffset: 2,
            color: "#444",
            backgroundColor: "rgb(93, 218, 173)"
          }
        };
      }
      if (event.type === "Classification") {
        return {
          style: {
            outline: isSelected ? "dashed 3px rgba(0, 0, 0, 0.2)" : undefined,
            outlineOffset: 2,
            color: "#444",
            backgroundColor: event.payload && (0, _PlantStateActivities.getPlantStateColor)(_this.props.theme, event.payload.state)
          }
        };
      }
      return {
        style: {
          outline: isSelected ? "dashed 3px rgba(0, 0, 0, 0.2)" : undefined,
          outlineOffset: 2
        }
      };
    };
    _this.handleDateChange = function (date) {
      var minDate = Math.min.apply(Math, _this.props.calendar.schedules.map(function (schedule) {
        return schedule.interval.startMillis;
      }));
      if (date.valueOf() >= minDate) {
        _this.setState({
          date: date
        });
      }
    };
    _this.handleViewChange = function (view) {
      _this.setState({
        view: view
      });
    };
    _this.handleSelectEvent = function (selectedEvent) {
      var onSelectEvent = _this.props.onSelectEvent;
      if (typeof onSelectEvent === "function") {
        onSelectEvent(selectedEvent);
      }
    };
    return _this;
  }
  _inheritsLoose(PlantCalendar, _Component);
  PlantCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.date === prevState.prevPropsDate) {
      return null;
    }
    return {
      date: props.date,
      prevPropsDate: props.date
    };
  };
  var _proto = PlantCalendar.prototype;
  _proto.getCurrentInterval = function getCurrentInterval() {
    var calendar = this.props.calendar;
    var _this$state = this.state,
      date = _this$state.date,
      view = _this$state.view;
    var start = calendar.getPlantTime(date.getTime());
    var end = start;
    if (view === "month" || view === "agenda") {
      start = start.startOf("month").startOf("week");
      end = end.endOf("month").endOf("week");
    } else if (view === "week") {
      start = start.plus({
        days: 1
      }).startOf("week").minus({
        days: 1
      });
      end = start.plus({
        days: 1
      }).endOf("week").plus({
        days: 1
      });
    } else {
      start = start.startOf("day").minus({
        hours: 12
      });
      end = end.endOf("day").plus({
        hours: 12
      });
    }
    var startMillis = start.valueOf();
    var endMillis = end.valueOf();
    return {
      startMillis: startMillis,
      endMillis: endMillis
    };
  };
  _proto.getVisibleEvents = function getVisibleEvents() {
    var _this$props = this.props,
      calendar = _this$props.calendar,
      agendaId = _this$props.agendaId,
      deviceUUID = _this$props.deviceUUID;
    var _this$getCurrentInter = this.getCurrentInterval(),
      startMillis = _this$getCurrentInter.startMillis,
      endMillis = _this$getCurrentInter.endMillis;
    var interval = {
      startMillis: startMillis - _timeDefinitions.DAY_IN_MILLIS,
      endMillis: endMillis + _timeDefinitions.DAY_IN_MILLIS
    };
    return calendar.getEventsOverlapping(interval, {
      agendaId: agendaId,
      deviceUUID: deviceUUID
    });
  };
  _proto.render = function render() {
    var _this$state2 = this.state,
      date = _this$state2.date,
      view = _this$state2.view;
    var _this$props2 = this.props,
      Component = _this$props2.component,
      calendar = _this$props2.calendar,
      allPlantStateActivities = _this$props2.plantStateActivities,
      theme = _this$props2.theme,
      onSelectEvent = _this$props2.onSelectEvent,
      selectedEvent = _this$props2.selectedEvent,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    // TODO: Check if needed
    // const plantStateActivities = getEnabledPlantStateActivities(
    //   this.props.plantStateActivities
    // );

    var events = this.getVisibleEvents();
    return /*#__PURE__*/_react["default"].createElement(_styledComponents2.PlantCalendarWrapper, null, /*#__PURE__*/_react["default"].createElement(Component, _extends({
      views: ["month", "week", "day"],
      selected: selectedEvent,
      onView: this.handleViewChange,
      onNavigate: this.handleDateChange,
      events: events,
      onSelectEvent: this.handleSelectEvent,
      showMultiDayTimes: true,
      eventPropGetter: this.getEventProps,
      titleAccessor: this.getEventTitle,
      startAccessor: this.getEventStart,
      endAccessor: this.getEventEnd,
      localizer: (0, _reactBigCalendar.momentLocalizer)(_moment["default"])
    }, extra, {
      view: view,
      date: date
    })));
  };
  return PlantCalendar;
}(_react.Component), _PlantCalendar.defaultProps = {
  date: new Date(Date.now()),
  theme: undefined,
  plantStateActivities: undefined,
  component: _reactBigCalendar.Calendar
}, _PlantCalendar)) || _class) || _class);